import Toast from "./Toast";

export default function ToastContainer({ toasts, removeToast }) {
    return (
        <div className="
            fixed bottom-6 left-6 z-[10000]
            flex flex-col gap-3
            pointer-events-none
        ">
            {toasts.map((toast) => (
                <div key={toast.id} className="pointer-events-auto">
                    <Toast
                        type={toast.type}
                        title={toast.title}
                        message={toast.message}
                        onClose={() => removeToast(toast.id)}
                    />
                </div>
            ))}
        </div>
    );
}
